<template>
  <div v-if="table.length" class="limits-table">
    <div
      v-for="(item, index) in table"
      :key="index"
      class="limits-table__row"
      :class="{ 'red': item.bgRed }"
    >
      <div
        class="limits-table__left"
        :class="{ 'red': item.bgRed }"
      >
        <SvgIcon :name="item.icon" class="limits-table__icon" />
        <UiText
          :text="item.label"
          font="body-text"
        />
      </div>
      <div
        class="limits-table__right"
        :class="{ 'red': item.bgRed }"
      >
        <UiText
          :text="item.value"
          font="body-text"
          :class="{ 'red': item.bgRed }"
        />
        <BaseInfoBtn
          v-if="item.unLimType"
          :data-id="`limit-modal-table-${index}`"
          :text="$t(`limits.maxValueToolTip.${item.unLimType}`)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseInfoBtn from '@/components/Base/InfoBtn'

export default {
  name: 'LimitsModalTable',
  components: {
    BaseInfoBtn,
  },
  props: {
    table: { type: Array, required: true }, // [{ label: '', value: '' }]
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
